import React from 'react'
import { lit } from 'src/utils'

export interface LogoCloudProps {
    /**
     * The class name to be used for styling purposes
     */
    className?: string

    /**
     * The class name to be used to hook GA event tracking
     */
    analyticsClassName?: string

    /**
     *  Images (or logos) to be rendered within the component
     */
    children: NonNullable<React.ReactNode>
}

export function LogoCloud({
    className,
    analyticsClassName = 'js_LogoCloud',
    children,
}: Readonly<LogoCloudProps>) {
    return (
        <div className={lit`bg-white py-4 ${className} ${analyticsClassName}`}>
            <div className="mx-auto max-w-7xl">
                <div className="-mx-6 grid grid-cols-2 place-items-center gap-0.5 overflow-hidden sm:mx-0 sm:rounded-2xl md:grid-cols-4">
                    {React.Children.map(children, (logo, i) => (
                        <div className="p-10 lg:px-20 lg:py-5" key={i}>
                            {logo}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
